var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFingerPointRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#ffffff;}  "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.656,198.255H297.953c-3.203,0-39.578,0-42.891,0c-14,0-37.188-4.25-20.578-27.375l57.484-48.422 c17.5-14.734,19.719-40.859,5.016-58.328c-14.75-17.5-40.859-19.734-58.359-5.031l-115.781,97.5 c-23.906,19.328-37.625,33.125-57.781,51.734C28.906,241.677,0,272.287,0,324.896c0,76.062,61.656,137.718,137.719,137.718H311.5 c20.078,0,36.344-16.266,36.344-36.328c0-10.844-4.828-20.453-12.359-27.125h5.672c20.063,0,36.328-16.25,36.328-36.328 c0-11.266-5.219-21.188-13.266-27.859c16.531-3.406,28.984-18.031,28.984-35.578c0-11.609-5.547-21.828-14.016-28.469h96.469 c20.063,0,36.344-16.266,36.344-36.328S495.719,198.255,475.656,198.255z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerPointRight);
export default __webpack_public_path__ + "static/media/finger-point-right.c912c2f0ae4207a3a01c1c4fd7d90611.svg";
export { ForwardRef as ReactComponent };